var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import { Field, getErrorMessage, withMountTracking, compose, } from "@atlassiansox/microscopekit";
import Button from '@atlaskit/button';
import styled from "styled-components";
import CredoStepProgress from "./credo-step-progress";
import { useCredoDispatch, useCredoState } from "../../credo-context";
import { RadioGroup } from "@atlaskit/radio";
import CrossIcon from '@atlaskit/icon/glyph/cross';
import showdown from "showdown";
import { enableFeedBackSurvey } from "./feedback-survey";
var AkQuestionCircleIcon = require("@atlaskit/icon/glyph/question-circle").default;
var InfoIcon = require("@atlaskit/icon/glyph/info").default;
var ErrorMessage = require("@atlaskit/form").ErrorMessage;
var Select = require("@atlaskit/select").default;
var CredoDacDocs = "http://go.atlassian.com/credo-dac";
var CredoTicketLink = 'https://ops.internal.atlassian.com/jira/browse/';
var QuestionIcon = styled(AkQuestionCircleIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  vertical-align: middle;\n"], ["\n  vertical-align: middle;\n"])));
var ReviewInfoIcon = styled(InfoIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  vertical-align: middle;\n"], ["\n  vertical-align: middle;\n"])));
var InfoDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: #dfe1e6;\n  border-color: #dfe1e6;\n  border-radius: 5px;\n  border-style: solid;\n  box-sizing: border-box;\n  font-size: 14px;\n  max-width: 100%;\n  overflow: hidden;\n  border-width: 1px;\n  padding: 10px;\n  font-size: 14px;\n  font-weight: 400;\n  span {\n    vertical-align: middle;\n    padding: 5px;\n  }\n"], ["\n  background-color: #dfe1e6;\n  border-color: #dfe1e6;\n  border-radius: 5px;\n  border-style: solid;\n  box-sizing: border-box;\n  font-size: 14px;\n  max-width: 100%;\n  overflow: hidden;\n  border-width: 1px;\n  padding: 10px;\n  font-size: 14px;\n  font-weight: 400;\n  span {\n    vertical-align: middle;\n    padding: 5px;\n  }\n"])));
var Container = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-bottom: 15px;\n    color: black;\n"], ["\n    padding-bottom: 15px;\n    color: black;\n"])));
var Link = styled.a(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var ProgressContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n"])));
var HeaderContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 24px;\n  padding-bottom: 10px;\n  > :nth-child(2) {\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 24px;\n  padding-bottom: 10px;\n  > :nth-child(2) {\n    cursor: pointer;\n  }\n"])));
var StepReviewTitle = styled.h4(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding-bottom: 10px;\n"], ["\n  padding-bottom: 10px;\n"])));
var QuestionReviewOverview = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 10px;\n  padding-left: 10px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 10px;\n  padding-left: 10px;\n"])));
var QuestionReview = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var DetailsReview = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var QuestionsReview = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var Detail = styled.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  color: grey\n"], ["\n  color: grey\n"])));
var ButtonContainer = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  > :first-child {\n    margin-right: 20px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  > :first-child {\n    margin-right: 20px;\n  }\n"])));
var AcceptAndCloseCredoActionContainer = styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  margin-top: 5px;\n  padding-top: 5px;\n  border-top: 1px solid #dfe1e6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-top: 5px;\n  padding-top: 5px;\n  border-top: 1px solid #dfe1e6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var CredoTaskStatusContainer = styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 5px;\n  padding-top: 5px;\n  margin-bottom: 5px;\n  padding-bottom:  5px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 5px;\n  padding-top: 5px;\n  margin-bottom: 5px;\n  padding-bottom:  5px;\n"])));
var AcceptAndCloseDeclarations = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  padding: 10px;\n  font-size: 12px;\n  font-weight: 200;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-top: 1px solid #dfe1e6;\n"], ["\n  padding: 10px;\n  font-size: 12px;\n  font-weight: 200;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-top: 1px solid #dfe1e6;\n"])));
var CredoTaskDetailsContainer = styled.table(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  padding: 10px;\n  display: block;\n  justify-content: center;\n  align-items: center;\n  th, td: {\n    vertical-align: middle;\n    text-align: center;\n    padding: 20px;\n  }\n"], ["\n  padding: 10px;\n  display: block;\n  justify-content: center;\n  align-items: center;\n  th, td: {\n    vertical-align: middle;\n    text-align: center;\n    padding: 20px;\n  }\n"])));
var CreateCredoButtonContainer = styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    margin: auto;\n"], ["\n    margin: auto;\n"])));
var tiers = [
    { label: 'Tier 3', value: 3 },
    { label: 'Tier 2', value: 2 },
    { label: 'Tier 1', value: 1 },
    { label: 'Tier 0', value: 0 },
    { label: 'SOC2', value: -1 },
];
var converter = new showdown.Converter();
var Header = function (_a) {
    var title = _a.title, onClose = _a.onClose;
    return (React.createElement(HeaderContainer, null,
        React.createElement("h3", null, title),
        onClose ? React.createElement("div", null,
            React.createElement(CrossIcon, { size: "small", label: "close", onClick: onClose })) : undefined));
};
var ServiceDetails = function () {
    var state = useCredoState();
    var dispatch = useCredoDispatch();
    return (React.createElement(Container, null,
        React.createElement(Field, { name: 'serviceTier', label: 'Service Tier', isRequired: true }, function () { return (React.createElement(Select, { value: tiers.find(function (t) { return t.value === state.tier; }), options: tiers, menuPortalTarget: document.body, styles: { menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); } }, onChange: function (val) {
                dispatch({ type: "setTier", data: { tier: val.value } });
            } })); }),
        React.createElement(Field, { name: 'serviceTemplate', label: 'Was your service created using the Microscope service wizard or Instant Micros?', isRequired: true }, function () { return (React.createElement(RadioGroup, { value: state.serviceTemplate ? 'true' : 'false', options: [
                { label: 'Yes', name: 'choice', value: 'true' },
                { label: 'No', name: 'choice', value: 'false' }
            ], onChange: function (e) {
                dispatch({ type: 'setServiceTemplate', data: { serviceTemplate: e.target.value === 'true' } });
            } })); })));
};
var CredoReview = function () {
    var state = useCredoState();
    var dispatch = useCredoDispatch();
    return (React.createElement(Container, null,
        state.credoTopics.map(function (step, i) { return (React.createElement(QuestionsReview, null,
            React.createElement(StepReviewTitle, { key: step.title },
                React.createElement("a", { dangerouslySetInnerHTML: { __html: converter.makeHtml(step.title) }, onClick: function (e) {
                        e.preventDefault();
                        e.nativeEvent.stopImmediatePropagation();
                        e.stopPropagation();
                        dispatch({ type: 'setPage', data: { value: 2 } });
                        dispatch({ type: 'setStep', data: { value: i } });
                    } })),
            step.questions.map(function (q, k) { return (React.createElement(QuestionReviewOverview, null,
                React.createElement(QuestionReview, null,
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: converter.makeHtml(q.question) } }),
                    React.createElement("span", null,
                        React.createElement("b", null, (q.options.find(function (o) { return o.option === state.credoResponses[i].answers[k].option; }) || { label: '' }).label))),
                (q.options.find(function (o) { return o.option === state.credoResponses[i].answers[k].option; }) || { details: '' }).details &&
                    React.createElement(DetailsReview, null,
                        React.createElement(Detail, null,
                            React.createElement("b", null, "Details:\u00A0")),
                        React.createElement(Detail, null,
                            React.createElement("i", null, state.credoResponses[i].answers[k].details))),
                state.credoResponses[i].answers[k].error &&
                    React.createElement(ErrorMessage, null, state.credoResponses[i].answers[k].error))); }))); }),
        React.createElement("p", null, "After the tickets are created, follow the links in their titles to Ops/J to finish them")));
};
var CredoComplete = function (_a) {
    var onClose = _a.onClose, history = _a.history;
    var state = useCredoState();
    var dispatch = useCredoDispatch();
    return (React.createElement(Container, null,
        React.createElement("span", null, "A Credo workflow has begun for your service. Would you like to be redirected to the workflow status?"),
        React.createElement(ButtonContainer, null,
            React.createElement(Button, { onClick: function () {
                    onClose();
                    dispatch({ type: 'resetCredoResponses' });
                    dispatch({ type: 'setStep', data: { value: 0 } });
                    dispatch({ type: 'setPage', data: { value: 0 } });
                } }, "Cancel"),
            React.createElement(Button, { onClick: function () {
                    dispatch({ type: 'resetCredoResponses' });
                    dispatch({ type: 'setStep', data: { value: 0 } });
                    dispatch({ type: 'setPage', data: { value: 0 } });
                    history.push("/services/" + state.serviceId + "/operations?workflowId=" + state.workflowId);
                } }, "Yes!"))));
};
var ReviewAndCompleteCredo = function (_a) {
    var completeCredoAction = _a.completeCredoAction, isLoading = _a.isLoading;
    var state = useCredoState();
    return (React.createElement(Container, null,
        React.createElement(InfoDiv, null,
            React.createElement("div", null,
                React.createElement(ReviewInfoIcon, { label: "Info", secondaryColor: "#DFE1E6", size: "medium" }),
                React.createElement("span", null,
                    React.createElement("a", { href: CredoTicketLink + state.credoOnGoingParentTicketDetails.ticketKey, title: state.credoOnGoingParentTicketDetails.ticketKey }, state.credoOnGoingParentTicketDetails.ticketKey),
                    ": ",
                    React.createElement("b", null, state.credoOnGoingParentTicketDetails.ticketStatus)),
                React.createElement("br", null),
                React.createElement("p", null, "Below ticket(s) have transitioned to \u201CDone\u201D status by the bot automatically. Please review the ticket(s) to conclude the Credo review.")),
            React.createElement(CredoTaskStatusContainer, null,
                React.createElement(CredoTaskDetailsContainer, null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Task(s)")),
                    state.credoOnGoingTicketDetails.map(function (ticket, i) { return (React.createElement("tr", { key: i },
                        React.createElement("td", null,
                            React.createElement("a", { href: CredoTicketLink + ticket.ticketKey, title: ticket.summary }, ticket.summary)))); })))),
        React.createElement(AcceptAndCloseDeclarations, null,
            React.createElement("span", null, "By clicking on \"Accept & Complete Credo\", your credo process completes.")),
        React.createElement(AcceptAndCloseCredoActionContainer, null,
            React.createElement(ButtonContainer, null,
                React.createElement(Button, { appearance: "primary", isLoading: isLoading, onClick: function () { return completeCredoAction(state.serviceId, state.credoOnGoingParentTicketDetails.ticketKey); } }, "Accept & Complete Credo")))));
};
var CredoModalView = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, startCredo = _a.startCredo, completeCredo = _a.completeCredo, track = _a.track, showFlag = _a.showFlag, history = _a.history;
    var _b = useState({ loading: false }), credoModal = _b[0], setCredoModal = _b[1];
    var state = useCredoState();
    var dispatch = useCredoDispatch();
    var nextPage = function () {
        if (state.page < pages.length - 1) {
            var value = state.page + 1;
            dispatch({ type: 'setPage', data: { value: value } });
        }
    };
    var prevPage = function () {
        if (state.page !== 0) {
            var value = state.page - 1;
            dispatch({ type: 'setPage', data: { value: value } });
        }
    };
    var completeCredoAction = function (serviceName, ticketId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, status_1, message, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track("Credo.CompleteCredoAction: Started", {
                        category: "info",
                    });
                    setCredoModal(__assign(__assign({}, credoModal), { loading: true }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, completeCredo({
                            variables: {
                                service: serviceName,
                                id: ticketId
                            },
                        })];
                case 2:
                    response = _a.sent();
                    status_1 = (response && response.data && response.data.completeCredoByService) ?
                        response.data.completeCredoByService.status : undefined;
                    message = (response && response.data && response.data.completeCredoByService) ?
                        response.data.completeCredoByService.message : undefined;
                    if (!status_1) {
                        throw new Error("Failed to get the status after starting Complete Credo Action flow");
                    }
                    if (status_1 === "error") {
                        throw new Error("Failed to perform Complete Credo Action flow. Error:" + message);
                    }
                    track("Credo.CompleteCredoAction: Succeeded", {
                        category: "info",
                    });
                    enableFeedBackSurvey(state.serviceId);
                    dispatch({ type: 'setPage', data: { value: 0 } });
                    dispatch({ type: 'setStep', data: { value: 0 } });
                    dispatch({ type: 'markCredoProcessComplete' });
                    history.go(0);
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    track("Credo.CompleteCredoAction: Failed", {
                        category: "error",
                    });
                    showFlag({
                        type: "error",
                        title: "Failed to complete credo process.",
                        message: getErrorMessage(error_1),
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setCredoModal(__assign(__assign({}, credoModal), { loading: false }));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var submitCredo = function (withoutResponses) { return __awaiter(void 0, void 0, void 0, function () {
        var answers, response, workflowId, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track("Credo.StartCredoWorkflow: Started", {
                        category: "info",
                    });
                    answers = state.credoResponses.reduce(function (ret, topic) { return (ret.concat(topic.answers.map(function (_a) {
                        var id = _a.id, option = _a.option, details = _a.details;
                        return ({ id: id, option: option, details: details });
                    }))); }, []);
                    setCredoModal(__assign(__assign({}, credoModal), { loading: true }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, startCredo({
                            variables: {
                                input: {
                                    serviceName: state.serviceId,
                                    tier: state.tier,
                                    soc2: state.soc2,
                                    serviceTemplate: state.serviceTemplate,
                                    answers: withoutResponses ? [] : answers
                                },
                            },
                        })];
                case 2:
                    response = _a.sent();
                    workflowId = (response && response.data && response.data.startCredoWorkflow) ?
                        response.data.startCredoWorkflow.id : undefined;
                    if (!workflowId) {
                        throw new Error("Failed to get workflow ID after starting Credo workflow");
                    }
                    track("Credo.StartCredoWorkflow: Succeeded", {
                        category: "info",
                    });
                    dispatch({ type: 'setWorkflowId', data: { workflowId: workflowId } });
                    dispatch({ type: 'resetCredoResponses' });
                    dispatch({ type: 'setPage', data: { value: pages.length - 2 } });
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    track("Credo.StartCredoWorkflow: Failed", {
                        category: "error",
                    });
                    showFlag({
                        type: "error",
                        title: "Failed to start credo workflow.",
                        message: getErrorMessage(error_2),
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setCredoModal(__assign(__assign({}, credoModal), { loading: false }));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var answersValid = function () { return !state.credoResponses.find(function (step) {
        return !!step.answers.find(function (answer) {
            return !!answer.error;
        });
    }); };
    var CredoInfo = function () { return (React.createElement(Container, null,
        React.createElement(InfoDiv, null,
            React.createElement("div", null,
                React.createElement(QuestionIcon, { label: "Info", secondaryColor: "#DFE1E6", size: "medium" }),
                React.createElement("span", null,
                    "For more information about Credo see the",
                    " ",
                    React.createElement("a", { href: CredoDacDocs }, "DAC Docs")))),
        React.createElement("ul", null,
            React.createElement("li", null,
                "Credo is now automated and self-service, letting you complete the process in less than 30 mins! Once you start Credo, it does most of the heavy-lifting for you, such as gathering evidence for Credo Jira tickets, auto-verifies and closing the Jira tickets upon satisfactory evidence!",
                React.createElement("a", { href: "https://developer.atlassian.com/platform/credo/self-service-pri-and-automation/#is-this-applicable-for-my-service--", rel: "noopener noreferrer" }, " Click here "),
                "to know if your service is in scope for automation."),
            React.createElement("li", null,
                "If it is not, please schedule a ",
                React.createElement("a", { href: "http://go/credo-review", rel: "noopener noreferrer" }, "manual review"),
                " once you have completed working on the Credo Jira tickets.")))); };
    // Order of the array matters a lot. Please be cautious while adding new element.
    var pages = [
        { title: 'Start a new Credo', content: React.createElement(CredoInfo, { submitCredo: submitCredo }) },
        { title: 'Service Details', content: React.createElement(ServiceDetails, null) },
        { content: React.createElement(CredoStepProgress, { onClose: onClose }), hideFooter: true },
        { title: 'Review Credo Details', content: React.createElement(CredoReview, null) },
        {
            title: 'Credo Started Successfully!',
            content: React.createElement(CredoComplete, { onClose: onClose, history: history }),
            hideFooter: true,
            hideClose: true
        },
        {
            title: 'Last step to complete credo...',
            content: React.createElement(ReviewAndCompleteCredo, { completeCredoAction: completeCredoAction, isLoading: credoModal.loading }),
            hideFooter: true
        }
    ];
    return (React.createElement(ModalTransition, null, isOpen &&
        React.createElement(ModalDialog, { onClose: onClose, shouldCloseOnOverlayClick: false, components: {
                Header: pages[state.page].title ? function () {
                    return React.createElement(Header, { title: pages[state.page].title, onClose: !pages[state.page].hideClose && !credoModal.loading ? onClose : undefined });
                } : undefined,
                Footer: (!pages[state.page].hideFooter ? function () { return (React.createElement(ProgressContainer, null, state.page === 0 &&
                    React.createElement(CreateCredoButtonContainer, null,
                        React.createElement(Button, { onClick: function () { return submitCredo(true); }, isLoading: credoModal.loading, appearance: 'primary' }, "Create my Credo tickets")))); } : undefined),
            } }, pages[state.page].content)));
};
var CredoModal = compose(withMountTracking('Credo.CredoModal'))(CredoModalView);
export default CredoModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;
